import { render } from "./NewAccountHeader.vue?vue&type=template&id=3cffad85&scoped=true"
import script from "./NewAccountHeader.vue?vue&type=script&lang=js"
export * from "./NewAccountHeader.vue?vue&type=script&lang=js"

import "./NewAccountHeader.vue?vue&type=style&index=0&id=3cffad85&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cffad85"],['__file',"src/common/components/layout/Header/NewAccountHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cffad85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cffad85', __exports__)) {
    api.reload('3cffad85', __exports__)
  }
  
  module.hot.accept("./NewAccountHeader.vue?vue&type=template&id=3cffad85&scoped=true", () => {
    api.rerender('3cffad85', render)
  })

}


export default __exports__